/* eslint-disable react/prop-types */
import React from 'react';

export const SafeIcon = ({name, color, size = '1.2em'}) => {
  let path = '';
  let viewBox = '0 0 512 512';
  if (name === 'save') {
    path = 'M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 ' +
      '0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 ' +
      '0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 ' +
      '28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 ' +
      '12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.249 ' +
      '1.264 8.5 3.515l32.48 32.485c2.25 2.251 3.5 5.317 3.5 8.5z';
    viewBox = '0 0 448 512';
  } else if (name === 'cancel') {
    path = 'M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24' +
      'c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-' +
      '12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 ' +
      '356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.19 12.28 ' +
      '44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.19 12.28 44.48 0l22.24-22.24' +
      'c12.28-12.28 12.28-32.19 0-44.48L242.72 256z';
    viewBox = '0 0 352 512';
  } else if (name === 'edit') {
    path = 'M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 ' +
      '0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 ' +
      '67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 ' +
      '262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 ' +
      '339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 ' +
      '19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 ' +
      '376H88v48z';
  }
  return (
    <svg viewBox={viewBox} width={size} height={size} fill={color} style={{'verticalAlign': '-0.125em'}}>
      <path d={path} />
    </svg>
  );
};

export const ThWithSort = ({label, sortKey, sortConfig, onSort, isSticky}) => (
  <th className={isSticky ? 'sticky-col' : ''}>
    <div style={{'display': 'flex', 'alignItems': 'center', 'justifyContent': 'space-between'}}>
      <span>{label}</span>
      <button
        className={`wma-sort-btn ${sortConfig.key === sortKey ? 'active' : ''}`}
        onClick={() => onSort(sortKey)}
      >
        {sortConfig.key === sortKey && sortConfig.dir === 'desc' ? '▼' : '▲'}
      </button>
    </div>
  </th>
);

export const ThFilter = ({colKey, filters, onChange, isSticky}) => (
  <th className={isSticky ? 'sticky-col' : ''} style={{'padding': '4px 8px', 'background': '#d4edf8'}}>
    <input
      className="wma-filter-input"
      placeholder="Buscar..."
      value={filters[colKey] || ''}
      onChange={(e) => onChange(colKey, e.target.value)}
    />
  </th>
);
